<template>
  <el-drawer title="详情" :visible.sync="drawer" :modal-append-to-body="false" append-to-body destroy-on-close custom-class="widthSpecial" :wrapperClosable="false">
    <el-form
      v-if="previewForm.flowVacationCustomDetail"
      ref="previewForm"
      status-icon
      :model="previewForm"
      size="small"
      class="mx-20-4 pl-10 bg-#fff pr-30 py-20"
      style="padding-bottom: 20px"
    >
      <div class="form-Title mx-20-2">申请信息</div>
      <el-form-item label="申请人：">{{ previewForm.flowVacationCustomDetail.applyStaffName || '-' }}</el-form-item>
      <el-form-item label="部门：">{{ previewForm.departmentName || '-' }}</el-form-item>
      <el-form-item label="请假类型：">{{ previewForm.flowVacationCustomDetail.vacationName }}</el-form-item>
      <el-form-item label="请假时间：">
        <span v-if="previewForm.flowVacationCustomDetail.timeUnit === 2">
          {{
            splitDay(
              previewForm.flowVacationCustomDetail.beginTime,
              previewForm.flowVacationCustomDetail.endTime,
              previewForm.flowVacationCustomDetail.beginStatus,
              previewForm.flowVacationCustomDetail.endStatus
            )
          }}
        </span>
        <span v-if="previewForm.flowVacationCustomDetail.timeUnit === 1">
          {{ splitTime(previewForm.flowVacationCustomDetail.beginTime, previewForm.flowVacationCustomDetail.endTime) }}
        </span>
      </el-form-item>
      <el-form-item label="请假时长：">
        {{ previewForm.flowVacationCustomDetail.vacationTime || 0 }}{{ dictType('timeUnitArr', previewForm.flowVacationCustomDetail.timeUnit) }}
      </el-form-item>
      <el-form-item label="请假事由：">{{ previewForm.flowVacationCustomDetail.vacationReason || '-' }}</el-form-item>
      <el-form-item v-if="previewForm.flowVacationCustomDetail.imageUrl" label="图片备注：">
        <ElImg v-for="(item, index) in previewForm.flowVacationCustomDetail.imageUrl.split(',')" :key="index" :src="item" />
      </el-form-item>
      <el-form-item v-if="previewForm.flowVacationCustomDetail.annexUrl && previewForm.flowVacationCustomDetail.annexUrl.length" label="附件：">
        <el-button type="primary" :loading="isDownloading" size="small" @click="downloadFile(previewForm.flowVacationCustomDetail.annexUrl)">下载</el-button>
      </el-form-item>
      <div class="form-Title mx-20-2">审批流程</div>
      <el-table :data="previewForm.flowAuditLogs" tooltip-effect="light" :header-cell-style="{ backgroundColor: '#ffffff', color: '#000' }">
        <el-table-column prop="flowConfigStepName" label="操作阶段" align="center">
          <template slot-scope="scope">
            {{ scope.row.operatePhase || '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="auditStaffName" label="操作人" align="center">
          <template slot-scope="scope">
            {{ scope.row.auditStaffName || '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="operateType" label="操作类型" align="center">
          <template slot-scope="scope">
            {{ dictType('operateTypeArr', scope.row.operateType) }}
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="操作时间" align="center">
          <template slot-scope="scope">
            {{ cutTime(scope.row.createTime, ' ') }}
          </template>
        </el-table-column>
      </el-table>
    </el-form>
    <el-form
      v-if="isExamine"
      ref="examinForm"
      label-width="83px"
      status-icon
      :model="examinForm"
      size="small"
      :rules="rules"
      label-position="left"
      class="mx-20-1 pt-24 bg-#fff pr-30"
    >
      <div class="form-Title mx-20-2">审批信息</div>
      <el-form-item label="审批结果：" prop="operateType">
        <el-radio v-model="examinForm.operateType" :label="3">通过</el-radio>
        <el-radio v-model="examinForm.operateType" :label="2">驳回</el-radio>
      </el-form-item>
      <el-form-item v-if="examinForm.operateType === 2" label="驳回原因：" prop="remark">
        <el-input v-angle="examinForm.remark" v-model="examinForm.remark" maxlength="30" show-word-limit placeholder="填写驳回原因" clearable />
      </el-form-item>
    </el-form>
    <FixedTwoButton v-if="isExamine" activeClass="widthSpecial">
      <ELButton size="small" describe="重置" :myFunction="resetForm" />
      <ELButton size="small" describe="提交" isAsync :myFunction="submitForm" type="primary" />
    </FixedTwoButton>
  </el-drawer>
</template>

<script>
import dayjs from 'dayjs'
import axios from 'axios'
import { baseURL } from '@/api/getFile'
import { getToken } from '@/utils/auth'
import { downloadFiles } from '@/utils/tool'
import formatData from '@/utils/formatRequestData'
import { flowApplyVacationInfo, flowApplyAudit } from '@/api/workManage'
export default {
  inject: ['indexThis'],
  props: {
    applyOverviewId: {
      type: String,
      default: '',
    },
    isExamine: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      drawer: false,
      isDownloading: false,
      previewForm: {},
      examinForm: { operateType: 3, remark: '' },
      rules: {
        operateType: [{ required: true, message: '审批结果不能为空', trigger: 'change' }],
        remark: [{ required: true, message: '驳回原因不能为空', trigger: 'blur' }],
      },
    }
  },
  watch: {
    'examinForm.operateType': {
      deep: true,
      handler(val) {
        if (val === 3) return
        this.examinForm.remark = ''
      },
    },
  },
  methods: {
    async getDetail(id) {
      const { data: res } = await flowApplyVacationInfo({ id: id || this.applyOverviewId })
      this.previewForm = res
    },
    async submitForm() {
      const valid = await this.$refs.examinForm.validate().catch(() => {})
      if (!valid) return false
      const { data: res } = await flowApplyAudit({
        ...formatData(this.examinForm),
        auditStaffId: this.$store.getters.staffId,
        auditStaffName: this.$store.getters.name,
        flowApplyOverviewId: this.applyOverviewId,
      })
      if (!res) return this.$message.error('审批失败')
      this.$message.success('审批成功')
      this.indexThis.init()
      this.resetForm()
      this.drawer = false
    },
    resetForm() {
      this.$refs.examinForm.resetFields()
    },
    splitDay(val1, val2, beginStatus, endStatus) {
      if (!val1 && !val2) return '-'
      if (val1 && !val2) return `${dayjs(val1).format('YYYY-MM-DD')} ${beginStatus == 1 ? '上午' : '下午'}至 -`
      if (!val1 && val2) return `- 至${dayjs(val2).format('YYYY-MM-DD')} ${endStatus == 1 ? '上午' : '下午'}`
      if (new Date(val1).getFullYear() === new Date(val2).getFullYear())
        return `${dayjs(val1).format('YYYY-MM-DD')} ${beginStatus == 1 ? '上午' : '下午'}至 ${dayjs(val2).format('MM-DD')} ${endStatus == 1 ? '上午' : '下午'}`
      return `${dayjs(val1).format('YYYY-MM-DD')} ${beginStatus == 1 ? '上午' : '下午'}至 ${dayjs(val2).format('YYYY-MM-DD')} ${endStatus == 1 ? '上午' : '下午'}`
    },
    splitTime(s, e) {
      if (!s && !e) return '-'
      if (s && !e) return dayjs(s).format('YYYY-MM-DD HH:mm') + ' 至 -'
      if (!s && e) return '- 至 ' + dayjs(e).format('YYYY-MM-DD HH:mm')
      if (new Date(s).getDate() === new Date(e).getDate()) return dayjs(s).format('YYYY-MM-DD HH:mm') + ' 至 ' + dayjs(e).format('HH:mm')
      if (new Date(s).getFullYear() === new Date(e).getFullYear()) return dayjs(s).format('YYYY-MM-DD HH:mm') + ' 至 ' + dayjs(e).format('MM-DD HH:mm')
      return dayjs(s).format('YYYY-MM-DD HH:mm') + ' 至 ' + dayjs(e).format('YYYY-MM-DD HH:mm')
    },

    // 下载
    downloadFile(urls) {
      if (!Array.isArray(urls)) {
        urls = [urls]
      }
      // 开始下载，设置 loading 为 true
      this.isDownloading = true
      let completedCount = 0
      urls.forEach((url, index) => {
        axios({
          url: `${baseURL}common/getFile?filePath=${url}&token=${getToken()}`,
          method: 'GET',
          responseType: 'blob',
        })
          .then(res => {
            const suffix = url.split('.')[1]
            downloadFiles(res, `请假申请附件-${index + 1}`, suffix)
            completedCount++
            // 所有文件下载完成，设置 loading 为 false
            if (completedCount === urls.length) {
              this.isDownloading = false
            }
          })
          .catch(() => {
            completedCount++
            if (completedCount === urls.length) {
              this.isDownloading = false
            }
          })
      })
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .el-form-item__label {
  text-align: left !important;
}
</style>
